import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { IPageContent } from '@/common/api/cms';
import { getTrainingPrograms } from '@/common/api/trainings';
import { IPageWithContentComponent } from '@/common/interfaces';
import { getBgImageStyle } from '@/common/styles';
import BookTrainingNavButton from '../../components/buttons/BookTrainingNavButton';
import PageDescription from '../../components/cms/PageDescription';
import { TrainingProgramsList } from '@/components/trainings-programs/TrainingProgramsList';
import { QuestionMark } from '@icons';

export interface ITrainingProgramsPageContent extends IPageContent {
  bottom_note: string;
}

export const TrainingProgramsPage: FC<IPageWithContentComponent<ITrainingProgramsPageContent>> = ({
  content,
}) => {
  const { isError, data: response } = useQuery({
    queryKey: ['training-programs'],
    queryFn: getTrainingPrograms,
  });

  return (
    <div
      style={{ ...getBgImageStyle(content.background_image_url), backgroundBlendMode: 'overlay' }}
      className="flex flex-1 h-fit min-h-full bg-no-repeat bg-fixed bg-cover bg-top bg-[rgba(255,255,255,0.7)]"
    >
      <div
        className="container mx-auto w-full h-max backdrop-blur-xs justify-center min-h-full lg:flex items-stretch gap-24 px-6 pb-6 pt-10"
        data-testid="trainings-container"
      >
        <div className="pt-6 basis-full lg:basis-1/3 flex flex-col gap-5 mb-3">
          <div className="flex flex-col gap-5">
            <PageDescription
              pageContent={content}
              titleClassname="font-bold"
              paragraphClassname="font-normal"
            />
            <div className="flex flex-row gap-3">
              <BookTrainingNavButton />
            </div>
          </div>
          <div className="flex gap-2">
            {content.bottom_note ? <QuestionMark fill="#0a6eb4" /> : null}
            <div
              className="text-default font-light cms-block cms-block-light"
              dangerouslySetInnerHTML={{ __html: content.bottom_note }}
            />
          </div>
        </div>
        <div className="basis-full lg:basis-2/3 mt-2">
          {isError ? (
            <div>Loading the training programs list unexpectedly failed.</div>
          ) : response ? (
            <TrainingProgramsList trainingPrograms={response.data.results} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TrainingProgramsPage;
